<div class="d-flex" style="height: 100%; overflow: hidden">
  <div style="height: 100%; max-height: 100%; overflow-y: auto; width: 100%">
    <table class="table-responsive table-bordered mt-3 p-2">
      <thead>
        <tr>
          <!-- Itera sobre las claves de la primera fila para crear las cabeceras de la tabla -->
          <th
            scope="col"
            style="font-weight: 700; padding: 10px"
            *ngFor="let header of rowData[0]"
            [style.backgroundColor]="'#004746'"
            [style.font-size]="validateFont(header,'size')"
            [style.color]="'white'"
          >
            {{ header.text }}
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- Itera sobre las filas de datos (empezando desde la segunda fila) -->
        <tr *ngFor="let row of rowData.slice(1)">
          <!-- Itera sobre las celdas de cada fila para crear las columnas de la tabla -->
          <td
            style="font-weight: 700"
            *ngFor="let cell of row"
            [style.backgroundColor]="'#dfdfde'"
            [style.font-size]="validateFont(cell,'size')"
            [style.color]="'#' + validateFont(header,'color')"
          >
            {{ cell.text }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
